import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconAssetTagStyle0 = gravityIconIndividualCss;

const GravityIconAssetTag = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'bb1052b0028d14f42dc7916f94f4684658f4bd64', color: this.color, size: this.size }, h("svg", { key: '7ada2d99574c9da82c415795f52d8ded94f4bf8a', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'c917be678c51ff9a23437ae9678e45b6d7d131e6', d: "M6.435 8.39a.25.25 0 0 1 .25-.25h1.59l.37-2.921A.25.25 0 0 1 8.893 5h1.19a.25.25 0 0 1 .248.283L9.953 8.14h2.834l.369-2.921A.25.25 0 0 1 13.404 5h1.172a.25.25 0 0 1 .248.283l-.377 2.857h1.265a.25.25 0 0 1 .25.25v1.034a.25.25 0 0 1-.25.25h-1.464l-.343 2.688h1.41a.25.25 0 0 1 .25.25v1.034a.25.25 0 0 1-.25.25h-1.608l-.37 2.886a.25.25 0 0 1-.247.218h-1.176a.25.25 0 0 1-.248-.28l.345-2.824H9.195l-.352 2.884a.25.25 0 0 1-.248.22H7.422a.25.25 0 0 1-.248-.282l.361-2.822H6.288a.25.25 0 0 1-.25-.25v-1.034a.25.25 0 0 1 .25-.25h1.446l.343-2.688H6.685a.25.25 0 0 1-.25-.25V8.39Zm2.923 3.972h2.923l.343-2.724H9.72l-.361 2.724Z", fill: "currentColor" }))));
    }
};
GravityIconAssetTag.style = GravityIconAssetTagStyle0;

export { GravityIconAssetTag as gravity_icon_asset_tag };

//# sourceMappingURL=gravity-icon-asset-tag.entry.js.map